module.exports = __webpack_public_path__ + "static/media/logo_require.93c1fbe9.png";